export const buildMonthlyExpensesPayload = (partial = {}) => {
  const normalizedTotal = Number(
    typeof partial.total === 'number' ? partial.total : partial.total || 0
  );
  const normalizedReceipts = Number(
    typeof partial.totalReceipts === 'number'
      ? partial.totalReceipts
      : partial.totalReceipts || 0
  );

  return {
    total: Number.isFinite(normalizedTotal) ? normalizedTotal : 0,
    updatedAt: partial.updatedAt || new Date().toISOString(),
    totalReceipts: Number.isFinite(normalizedReceipts) ? normalizedReceipts : 0,
    categories: Array.isArray(partial.categories) ? partial.categories : [],
  };
};

export const setMonthlyExpensesCache = (partial = {}) => {
  const payload = buildMonthlyExpensesPayload(partial);
  try {
    localStorage.setItem('monthly_expenses', JSON.stringify(payload));
    localStorage.setItem('monthly_expenses_value', payload.total.toString());
  } catch (error) {
    console.error('Failed to persist monthly expenses cache:', error);
  }

  if (typeof window !== 'undefined') {
    try {
      window.dispatchEvent(
        new CustomEvent('rsnap:monthlyExpensesReset', { detail: payload })
      );
    } catch (error) {
      console.error('Failed to dispatch monthly expenses reset event:', error);
    }
  }
};

export const resetMonthlyExpensesCache = () => {
  setMonthlyExpensesCache({
    total: 0,
    totalReceipts: 0,
    categories: [],
  });
};

export const getStoredMonthlyExpensesTotal = () => {
  const raw = localStorage.getItem('monthly_expenses');
  if (!raw) return 0;

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === 'number') {
      return Number.isFinite(parsed) ? parsed : 0;
    }
    if (parsed && typeof parsed === 'object') {
      if (typeof parsed.total === 'number') {
        return parsed.total;
      }
      const numericTotal = Number(parsed.total);
      return Number.isFinite(numericTotal) ? numericTotal : 0;
    }
  } catch (error) {
    const numericValue = Number(raw);
    if (Number.isFinite(numericValue)) {
      return numericValue;
    }
  }

  const fallback = parseFloat(raw);
  return Number.isFinite(fallback) ? fallback : 0;
};

